import type { FormGroup } from '@angular/forms';
import { ADDRESS_VALIDATION_ERROR_KEYS } from '../validators/address-field.validators';
import {
  resolveUnserviceableAddressSections,
  type UnserviceableAddressSectionKey,
} from './resolve-unserviceable-address-sections';

const SECTION_FORM_KEYS: UnserviceableAddressSectionKey[] = ['shipFrom', 'shipTo', 'returnAddress'];

/**
 * Clears group-level serviceability errors from all address sections.
 */
export function clearAddressServiceabilityErrors(form: FormGroup): void {
  for (const sectionKey of SECTION_FORM_KEYS) {
    const sectionGroup = form.get(sectionKey) as FormGroup | null;
    if (!sectionGroup?.hasError(ADDRESS_VALIDATION_ERROR_KEYS.addressUnserviceable)) {
      continue;
    }

    const remainingErrors = { ...sectionGroup.errors };
    delete remainingErrors[ADDRESS_VALIDATION_ERROR_KEYS.addressUnserviceable];
    sectionGroup.setErrors(Object.keys(remainingErrors).length > 0 ? remainingErrors : null);
  }
}

/**
 * Applies group-level unserviceable errors to the sections identified by the API message.
 */
export function applyAddressServiceabilityErrors(form: FormGroup, message: string): void {
  clearAddressServiceabilityErrors(form);

  for (const sectionKey of resolveUnserviceableAddressSections(message)) {
    const sectionGroup = form.get(sectionKey) as FormGroup | null;
    if (!sectionGroup) {
      continue;
    }

    sectionGroup.setErrors({
      ...sectionGroup.errors,
      [ADDRESS_VALIDATION_ERROR_KEYS.addressUnserviceable]: true,
    });
    sectionGroup.markAllAsTouched();
  }
}
